let globalCanvasWrapper = null;

document.addEventListener("click", function (e) {
  // Handle Preview Close/Overlay
  if (e.target.closest("#preview-close") || e.target.closest("#preview-overlay") || e.target.closest(".btn-closed")) {
    const galleryWrap = document.querySelector(".gallery-wrap");
    const productNameTitle = document.querySelector(".product_name_title");
    
    if (
      window.innerWidth < 992 &&
      galleryWrap &&
      !galleryWrap.querySelector(".canvas-wrapper") &&
      productNameTitle &&
      productNameTitle.textContent &&
      productNameTitle.textContent.indexOf('Photo') !== -1
    ) {
      if (globalCanvasWrapper) {
        galleryWrap.prepend(globalCanvasWrapper);
      }
    }
    e.preventDefault();
    const previewContainer = document.getElementById("preview-container");
    if (previewContainer) {
      previewContainer.classList.toggle("hidden");
    }
  }

  // Handle Preview Buttons
  if (e.target.closest("#btn-preview") || e.target.closest("#btn-preview-desktop")) {

    console.log('Preview button clicked');
    e.preventDefault();
    check_valid();
    
    // Find all customily options that have an error
    const errorOptions = Array.from(document.querySelectorAll(".customily_option.customily-required-error"));
    
    // Check if any error option is actually visible
    const hasVisibleError = errorOptions.some(function(el) {
      const isVisuallyHidden = el.getAttribute("visually-hidden") === "true";
      const isDisplayNone = getComputedStyle(el).display === "none";
      return !isVisuallyHidden && !isDisplayNone;
    });

    if (hasVisibleError) {
      const previewContainer = document.getElementById("preview-container");
      if (previewContainer) previewContainer.style.display = 'none';
      
      const firstError = errorOptions[0];
      if (firstError) {
        const input = firstError.querySelector("input");
        const select = firstError.querySelector("select");
        const textarea = firstError.querySelector("textarea");
        
        if (input) input.focus();
        else if (select) select.focus();
        else if (textarea) textarea.focus();
        
        firstError.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
      return;
    }
    
    const productNameTitle = document.querySelector(".product_name_title");
    
    if (window.innerWidth < 992 && productNameTitle && productNameTitle.textContent && productNameTitle.textContent.indexOf('Photo') !== -1) {
      globalCanvasWrapper = document.querySelector(".canvas-wrapper");
      const previewImageWrap = document.querySelector(".preview-image-wrap");
      if (previewImageWrap && globalCanvasWrapper) {
        previewImageWrap.innerHTML = '';
        previewImageWrap.appendChild(globalCanvasWrapper);
      }
    } else {
      const canvas = document.getElementById("preview-canvas");
      if (canvas) {
        const dataURL = canvas.toDataURL();
        const previewImg = document.getElementById("preview-img");
        if (previewImg) previewImg.setAttribute("src", dataURL);
      }
    }

    const previewContainer = document.getElementById("preview-container");
    if (previewContainer) {
      previewContainer.classList.remove("hidden");
      previewContainer.style.display = 'block';
    }
  }
});

function toggleCustomilyError(element, isValid) {
  const optionContainer = element.closest(".customily_option");
  if (!optionContainer) return;
  
  const labelSpan = optionContainer.querySelector(".customily-required-label span");
  
  if (isValid) {
    optionContainer.classList.remove("customily-required-error");
    if (labelSpan) labelSpan.style.display = 'none';
  } else {
    optionContainer.classList.add("customily-required-error");
    if (labelSpan) labelSpan.style.display = '';
  }
}

function check_valid() {
  const optionsWrapper = document.getElementById("customily-options");
  if (!optionsWrapper) return;

  optionsWrapper.querySelectorAll(".swatch-container").forEach(function (container) {
    const checked = container.querySelector('input[type="radio"]:checked');
    toggleCustomilyError(container, !!checked);
  });

  optionsWrapper.querySelectorAll("select").forEach(function (select) {
    toggleCustomilyError(select, !!select.value);
  });

  optionsWrapper.querySelectorAll('input[type="text"]').forEach(function (input) {
    toggleCustomilyError(input, input.value.trim().length > 0);
  });

  optionsWrapper.querySelectorAll("textarea").forEach(function (textarea) {
    toggleCustomilyError(textarea, textarea.value.trim().length > 0);
  });

  optionsWrapper.querySelectorAll(".customily-file-input").forEach(function (fileInput) {
    const removeBtn = fileInput.querySelector(".cl_remove-image");
    // Check if the remove button exists and is visible (which means an image was uploaded)
    const isVisible = removeBtn && (removeBtn.offsetWidth > 0 || removeBtn.offsetHeight > 0 || getComputedStyle(removeBtn).display !== 'none');
    toggleCustomilyError(fileInput, isVisible);
  });
}

// ── Moved from product-form.js ──────────────────────────────────────────────

const keySaveProperties = "add-to-cart";
function setLocalStorageItem(key, value, ttl) {
  if (!key) {
    return;
  }
  const now = new Date();
  const item = {
    value,
    expiry: ttl ? now.getTime() + ttl * 3600000 : null,
  };
  localStorage.setItem(key, JSON.stringify(item));
}

function getLocalStorageItem(key) {
  if (!key) {
    return;
  }
  const itemStr = localStorage.getItem(key);
  if (!itemStr) {
    return null;
  }
  try {
    const item = JSON.parse(itemStr);
    const now = new Date();
    if (now.getTime() > item.expiry) {
      localStorage.removeItem(key);
      return null;
    }
    return item.value;
  } catch (e) {
    localStorage.removeItem(key);
    return null;
  }
}

const dataPropertiesCache = getLocalStorageItem(keySaveProperties);
const initForm = document.querySelector(".product_form.init");
const productId = initForm ? initForm.getAttribute("data-product-id") : null;
// handle addToCart
function addToCart() {
  const urlCurrent = window.location.href;

  if (
    urlCurrent.includes("fri13062202vupg") ||
    urlCurrent.includes("dog09062202nght") ||
    urlCurrent.includes("matching-shirts")
  ) {
    return;
  }
  const formAddToCart = document.querySelector("form[action='/cart/add']");
  if (!formAddToCart) return;
  const formData = new FormData(formAddToCart);
  var urlCustomization = formData.get("properties[_customily-customization-url]");

  if (!urlCustomization) {
    return;
  }

  const variantID = new URL(urlCustomization).searchParams.get("variant");
  const item = {
    variantID,
    productId,
    urlCustomization,
  };

  if (dataPropertiesCache) {
    const indexProductAdd = dataPropertiesCache.findIndex(
      (item) => item.productId === productId
    );
    if (indexProductAdd !== -1) {
      dataPropertiesCache.splice(indexProductAdd, 1, item);
    } else {
      dataPropertiesCache.push(item);
    }
    setLocalStorageItem(keySaveProperties, dataPropertiesCache, 2);
  } else {
    const initListAddToCart = [item];
    setLocalStorageItem(keySaveProperties, initListAddToCart, 2);
  }
}

const productInfoForm = document.querySelector("product-info form[action='/cart/add']");
if (productInfoForm) {
  productInfoForm.addEventListener("submit", function () {
    addToCart();
  });
}

function syncLoaddingAddToCart() {
  const timerLoading = setInterval(() => {
    const customilyBtn = document.getElementById("customily-cart-btn");
    const previewBtn = document.getElementById("customily-cart-btn-preview");
    
    if (customilyBtn && previewBtn) {
      if (
        customilyBtn.classList.contains("disable-pointer-events") ||
        customilyBtn.hasAttribute("disabled")
      ) {
        previewBtn.classList.add("ld-custom");
      } else {
        previewBtn.classList.remove("ld-custom");
        clearInterval(timerLoading);
      }
    } else {
      clearInterval(timerLoading);
    }
  }, 100);
}

const waitUntilElementExists = (option, selector, callback) => {
  const el = document.querySelector(selector);

  if (el) {
    return callback(option, selector);
  }
  setTimeout(function () {
    waitUntilElementExists(option, selector, callback);
  }, 200);
};
function FillDataOptionCustomily(option, selector) {
  const el = document.querySelector(selector);
  if (option.type === "Dropdown") {
    el.value = option.value;
    el.dispatchEvent(new Event("change"));
  } else if (option.type === "Swatch") {
    const els = document.querySelectorAll(selector);
    for (const i of els) {
      if (i.value === option.value) {
        i.checked = true;
        i.dispatchEvent(new Event("change"));
        return;
      }
    }
  } else if (option.type === "Text Input") {
    el.value = option.value;
    const eventOnChange = new Event("input", {
      bubbles: true,
      cancelable: true,
    });
    el.dispatchEvent(eventOnChange);
    return;
  } else if (option.type === "Checkbox") {
    if (option.value === "true") {
      el.checked = true;
      el.dispatchEvent(new Event("change"));
    }
  }
}
function setCheckedInput(indexItem, arrVariant) {
  const inputs = document.querySelectorAll(`[data-option-index="${indexItem}"] input`);
  const dataVariant = arrVariant[indexItem];
  
  inputs.forEach(function (input) {
    if (input.value == dataVariant.trim()) {
      input.setAttribute("checked", "true");
      input.checked = true;
      const swatchElement = input.nextElementSibling;
      if (swatchElement) {
        const swatchValue = swatchElement.getAttribute("data-value");
        const parentForm = swatchElement.closest(".product_form");
        
        if (parentForm && swatchValue) {
          const siblingInput = parentForm.querySelector(`input[value="${swatchValue.toString().replace(/\"/g, '\\"')}"]`);
          if (siblingInput) {
            siblingInput.checked = true;
            siblingInput.dispatchEvent(new Event('change', { bubbles: true }));
          }
          
          let JSONData;
          try {
            JSONData = JSON.parse(parentForm.getAttribute("data-product"));
          } catch (e) {}
          
          const productSection = ".product-" + productId + " .js-product_section";
          const swatchOptions = parentForm.querySelectorAll(".swatch_options .swatch");
          
          if (swatchOptions.length > 1 && JSONData && window.Shopify && Shopify.linkOptionSelectors) {
            Shopify.linkOptionSelectors(JSONData, productSection);
          }
        }
      }
    } else {
      input.removeAttribute("checked");
      input.checked = false;
    }
  });
}
function getShareCustomily() {
  var cacheProductCurrent = dataPropertiesCache.find(function (element) {
    return element.productId === productId;
  });
  const { urlCustomization, variantID } = cacheProductCurrent;

  var optionSelected;
  document.querySelectorAll(".multi_select option").forEach(function (opt) {
    if (opt.value == variantID) {
      opt.setAttribute("selected", "selected");
      opt.selected = true;
      optionSelected = opt.textContent;
    }
  });
  if (optionSelected) {
    var arrVariant = optionSelected.split("/");
    setCheckedInput(0, arrVariant);
    setCheckedInput(1, arrVariant);
    setCheckedInput(2, arrVariant);
  }
  if (urlCustomization) {
    const urlParams = new URLSearchParams(urlCustomization);
    var customizationId = urlParams.get("customizationId");
    if (!customizationId) {
      const indexCut = urlCustomization.lastIndexOf("=");
      customizationId = urlCustomization.slice(
        indexCut + 1,
        urlCustomization.length
      );
    }
    if (window.engraver && window.engraver.getSharedCustomization) {
      window.engraver
        .getSharedCustomization(customizationId)
        .then(async (res) => {
          const { CustomizationData } = res;
          const customizationData = JSON.parse(CustomizationData);
          const { options } = customizationData;
          for (const option of options) {
            const { sortId, type } = option;
            const sortIdDom = `[sort-id="${sortId}"]`;
            var checkVisuallyHiddenElement = document.querySelector(sortIdDom);
            if (
              checkVisuallyHiddenElement &&
              checkVisuallyHiddenElement.attributes["visually-hidden"]
            ) {
              continue;
            }

            var tagName;
            if (
              type === "Swatch" ||
              type === "Checkbox" ||
              type === "Text Input"
            ) {
              tagName = "input";
            }
            if (type === "Dropdown") {
              tagName = "select";
            }

            if (!tagName) {
              continue;
            }
            const el = sortIdDom + " " + tagName;
            waitUntilElementExists(option, el, FillDataOptionCustomily);
          }
        });
    }
  }
}

window.addEventListener("load", function () {
  const isProductDetailPage = document.querySelector(
    ".product__info-wrapper.grid__item"
  );

  if (!isProductDetailPage) {
    return;
  }

  const urlCurrent = window.location.href;

  if (
    urlCurrent.includes("fri13062202vupg") ||
    urlCurrent.includes("dog09062202nght") ||
    urlCurrent.includes("matching-shirts")
  ) {
    return;
  }

  // filter product current in cache
  let cacheProductCurrent;
  if (dataPropertiesCache) {
    cacheProductCurrent = dataPropertiesCache.find(function (element) {
      return element.productId === productId;
    });
  }

  if (!cacheProductCurrent) {
    return;
  }

  const notiShipping = document.querySelector(".notification-shipping");
  if (notiShipping && notiShipping.classList.contains("hidden")) {
    modalConfirm("getShareCustomily");
  }
});
function closeModalConfirm() {
  const modal = document.getElementById("wrapper-modal-confirm");
  if (modal) modal.classList.remove("is-open");
}

document.addEventListener("click", function(e) {
  // Cancel confirm modal
  if (e.target.closest(".handle-cancel-confirm-modal, .overlay-modal-confirm, .btn-closed-reorder")) {
    const btnCustomize = document.getElementById("js-btn-customzize");
    if (btnCustomize) btnCustomize.click();
    closeModalConfirm();
  }
  
  // Ok confirm modal
  const okConfirm = e.target.closest(".handle-ok-confirm-modal");
  if (okConfirm) {
    const redirect = okConfirm.getAttribute("redirect");
    if (redirect == "getShareCustomily") {
      getShareCustomily();
    } else {
      handleConfirmRemoveCart(redirect);
    }
    closeModalConfirm();
  }

  // Quantity box minus/plus
  const qtyBoxBtn = e.target.closest(".button-minus-box, .button-plus-box");
  if (qtyBoxBtn) {
    const input = document.querySelector('input[name="quantity-box"]');
    if (input) {
      let qty = parseInt(input.value, 10) || 0;
      if (qtyBoxBtn.classList.contains("button-minus-box")) {
        if (qty > 1) qty--;
      } else {
        qty++;
      }
      input.value = qty;
    }
  }

  // General Quantity minus/plus
  const qtyBtn = e.target.closest(".qty-plus, .qty-minus");
  if (qtyBtn) {
    const parent = qtyBtn.parentElement;
    if (parent) {
      const input = parent.querySelector("input.variant-quantity");
      if (input) {
        let qty = parseInt(input.value, 10) || 0;
        if (qtyBtn.classList.contains("qty-minus")) {
          if (qty > 1) qty--;
        } else {
          qty++;
        }
        input.value = qty;
      }
    }
  }
});

function initOpenModal() {
  const modal = document.getElementById("wrapper-modal-confirm");
  if (modal) modal.classList.add("is-open");
}

function modalConfirm(redirect) {
  initOpenModal();
  document.querySelectorAll(".handle-ok-confirm-modal").forEach(el => {
    el.setAttribute("redirect", redirect);
  });
}

var getThisElementHandle; // class name element btn trigger modal
function handleConfirmRemoveCart(redirect) {
  if (!getThisElementHandle) return;
  const triggerEl = typeof getThisElementHandle === 'string' ? document.querySelector(getThisElementHandle) : getThisElementHandle;
  if (!triggerEl) return;
  
  const parentCartItem = triggerEl.closest("[data-cart-item]");
  if (!parentCartItem) return;

  const lineID = parentCartItem.getAttribute("data-line-id");
  const cartItem = {
    lineID: lineID,
    quantity: 0,
    $element: window.jQuery ? window.jQuery(parentCartItem) : parentCartItem 
  };

  parentCartItem.classList.add("animated", "fadeOutLeft");

  if (typeof updateCartItem === 'function') {
    updateCartItem(cartItem, redirect);
  }
}
document.body.addEventListener("click", function (e) {
  if (
    e.target.closest(".customily-file-input") &&
    document.querySelectorAll(".cl_remove-image").length
  )
    observeRemoveButton(e.target.closest(".customily-file-input"));
});

function observeRemoveButton(selector) {
  if (!selector) return;
  let buttonRemove = selector.querySelector(".cl_remove-image");
  if (!buttonRemove) return;

  // Apply initial state
  function updateLabel() {
    if (!buttonRemove) return;
    buttonRemove.style.display == "none"
      ? selector.classList.remove("arnLabel-show")
      : selector.classList.add("arnLabel-show");
  }
  updateLabel();

  // Watch for style/attribute changes instead of polling forever
  const observer = new MutationObserver(updateLabel);
  observer.observe(buttonRemove, { attributes: true, attributeFilter: ["style", "class"] });

  // Safety: disconnect after 30s to prevent any leak
  setTimeout(() => observer.disconnect(), 30000);
}
document.addEventListener("DOMContentLoaded", function () {
  const customilyOptions = document.querySelector("#customily-options:not([style*='display: none;'])");
  
  if (customilyOptions) {
    const timerRemoveLoadingPreview = setInterval(function () {
      const isCartBtnReady = document.querySelector(
        "#customily-options:not([style*='display: none;']) ~.product-form__buttons #customily-cart-btn:not(.running)"
      );
      
      if (isCartBtnReady) {
        const btnDesktop = document.getElementById("btn-preview-desktop");
        const btnMobile = document.getElementById("btn-preview");
        
        if (btnDesktop) btnDesktop.classList.remove("ld-custom");
        if (btnMobile) btnMobile.classList.remove("ld-custom");
        
        clearInterval(timerRemoveLoadingPreview);
      }
    }, 100);
  }

  const btnBuy = document.querySelector("#preview-container button[type='submit']");
  if (btnBuy) {
    btnBuy.addEventListener("click", function () {
      this.classList.add("ld-over-inverse", "running");
      this.insertAdjacentHTML('beforeend', "<div class='ld ld-cycle ld-ring'></div>");
    });
  }
});
const jsSavePreviewBtn = document.getElementById("js-save-properties-product-preview");
if (jsSavePreviewBtn) {
  jsSavePreviewBtn.addEventListener("click", function (e) {
    const previewBtn = document.getElementById("customily-cart-btn-preview");
    const cartBtn = document.getElementById("customily-cart-btn");
    
    if (previewBtn) previewBtn.classList.add("ld-custom");
    if (cartBtn) cartBtn.click();
  });
}